export enum PipelineStageGroupEnum {
  Prospect = 'prospect',
  Active = 'active',
  Loi = 'loi',
  UnderContract = 'under_contract',
  ClosedWon = 'closed_won',
}
